import React, { useRef, useEffect, useState } from "react";
import Measurement from "@arcgis/core/widgets/Measurement.js";

import Legend from "@arcgis/core/widgets/Legend.js";


const MeasurementWidget = (mapView) => {
  const [activeTool, setActiveTool] = useState(null);
  const measurementRef = useRef(null);
  const legendRef = useRef(null);
  const measurementDivRef = useRef(null);

  useEffect(() => {
    let measurement, legend;

    if (mapView ) {

      // Initialize Measurement widget
      measurement = new Measurement({
        view: mapView.view,
      });
      mapView.view.ui.add(measurement, "bottom-right");
      measurementRef.current = measurement;

      // Initialize Legend widget
      legend = new Legend({
        view: mapView.view,
        layerInfos: [
          {
            layer: mapView.view.map.layers.getItemAt(1), // Assuming feature layer is second in the map
            title: "European Capital Cities",
          },
        ],
      });
      // mapView.view.ui.add(legend, "bottom-left");
      legendRef.current = legend;

    }

    return () => {
      // Cleanup Measurement and Legend widgets
      if (measurementRef.current) {
        mapView.view.ui.remove(measurementRef.current);
        measurementRef.current.destroy();
      }
      if (legendRef.current) {
        mapView.view.ui.remove(legendRef.current);
        legendRef.current.destroy();
      }
    };
  }, [mapView]);

  const activateDistanceMeasurement = () => {
    if (measurementRef.current) {
      setActiveTool("distance");
      measurementRef.current.activeTool = "distance";
    }
  };

  const activateAreaMeasurement = () => {
    if (measurementRef.current) {
      setActiveTool("area");
      measurementRef.current.activeTool = "area";
    }
  };

  const clearMeasurements = () => {
    if (measurementRef.current) {
      setActiveTool(null);
      measurementRef.current.clear();
    }
  };

  return (
    <div>
      <div id="toolbarDiv" className="esri-component " style={{ textAlign: "center" }}>
        <button
          id="btnDistanceTool"
          className={`btn btn-outline-primary  esri-icon-measure-line ${activeTool === "distance" ? "active" : ""
            }`}
          title="Distance Measurement Tool"
          onClick={activateDistanceMeasurement}
          style={{ marginRight: "10px" }}
        ></button>
        <button
          id="btnAreaTool"
          className={`btn btn-outline-primary  esri-icon-measure-area ${activeTool === "area" ? "active" : ""
            }`}
          title="Area Measurement Tool"
          onClick={activateAreaMeasurement}
          style={{ marginRight: "10px" }}
        ></button>
        <button
          id="btnMeasureClear"
          className="btn btn-outline-danger  esri-icon-trash"
          title="Clear Measurements"
          onClick={clearMeasurements}
        ></button>
         {/* <div ref={measurementDivRef} className="esri-component esri-measurement" style={{ height: "250px" }}></div> */}
         
      </div>
    </div>
  );
};

export default MeasurementWidget;
